(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["country-domain-switch-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LOG_PREFIX = '[GeoDomainSwitch]';

    function log(level, message, payload) {
      if (typeof console === 'undefined') return;
      if (payload !== undefined) {
        console[level](LOG_PREFIX + ' ' + message, payload);
        return;
      }
      console[level](LOG_PREFIX + ' ' + message);
    }

    function normalizeHost(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '')
        .split('/')[0];
    }

    function getDismissKey(sectionId, rule) {
      return 'geo-domain-switch:' + sectionId + ':' + rule.country + ':' + rule.source_host;
    }

    function getStorage() {
      try {
        return window.sessionStorage;
      } catch (e) {
        return null;
      }
    }

    function run(root, sectionId, visitorCountry, currentHost, testMode) {
      var rulesElement = root.querySelector('[data-geo-rules]');
      var dialog = root.querySelector('.geo-domain-switch__dialog');
      var heading = root.querySelector('[data-geo-heading]');
      var message = root.querySelector('[data-geo-text]');
      var switchLink = root.querySelector('[data-geo-switch-link]');
      var stayButton = root.querySelector('[data-geo-stay]');
      var closeButton = root.querySelector('[data-geo-close]');

      log('info', 'Setup started.', {
        sectionId: sectionId,
        visitorCountry: visitorCountry,
        currentHost: currentHost,
        testMode: testMode
      });

      if (!rulesElement || !dialog || !heading || !message || !switchLink || !stayButton || !closeButton) {
        log('warn', 'Missing required popup elements.', {
          hasRulesElement: Boolean(rulesElement),
          hasDialog: Boolean(dialog),
          hasHeading: Boolean(heading),
          hasMessage: Boolean(message),
          hasSwitchLink: Boolean(switchLink),
          hasStayButton: Boolean(stayButton),
          hasCloseButton: Boolean(closeButton)
        });
        return;
      }

      var parsed;
      try {
        parsed = JSON.parse(rulesElement.textContent);
      } catch (error) {
        log('error', 'Failed to parse rules JSON.', error);
        return;
      }

      var rules = parsed && Array.isArray(parsed.rules) ? parsed.rules : [];
      log('info', 'Rules loaded.', rules);

      if (!visitorCountry) {
        log('warn', 'Visitor country is empty. No country rule can match.');
      }

      rules.forEach(function (rule, index) {
        var sourceHost = normalizeHost(rule.source_host);
        var country = String(rule.country || '').toUpperCase();
        log('info', 'Evaluating rule.', {
          ruleIndex: index,
          ruleCountry: country,
          ruleSourceHost: sourceHost,
          countryMatches: country === visitorCountry,
          hostMatches: sourceHost === currentHost
        });
      });

      var activeRule = rules.find(function (rule) {
        var sourceHost = normalizeHost(rule.source_host);
        var country = String(rule.country || '').toUpperCase();
        return Boolean(country && sourceHost && country === visitorCountry && sourceHost === currentHost);
      });

      if (!activeRule) {
        log('warn', 'No matching rule found. Popup will not show.');
        return;
      }

      log('info', 'Matched rule.', activeRule);

      var dismissKey = getDismissKey(sectionId, activeRule);
      var storage = getStorage();

      if (!testMode && storage && storage.getItem(dismissKey) === '1') {
        log('info', 'Popup previously dismissed this session.', { dismissKey: dismissKey });
        return;
      }

      var targetHost = normalizeHost(activeRule.target_host);
      if (!targetHost) {
        log('warn', 'Matched rule is missing target host.', activeRule);
        return;
      }

      var cleanParams = new URLSearchParams(window.location.search);
      cleanParams.delete('geo_country');
      var searchString = cleanParams.toString() ? '?' + cleanParams.toString() : '';
      var targetUrl = window.location.protocol + '//' + targetHost + window.location.pathname + searchString + window.location.hash;

      heading.textContent = activeRule.heading || '';
      message.textContent = activeRule.message || '';
      switchLink.textContent = activeRule.switch_label || '';
      stayButton.textContent = activeRule.stay_label || '';
      switchLink.href = targetUrl;

      function dismiss() {
        if (!testMode && storage) {
          storage.setItem(dismissKey, '1');
        }
        log('info', 'Popup dismissed.', { dismissKey: dismissKey, testMode: testMode });
        dialog.style.display = 'none';
      }

      closeButton.addEventListener('click', dismiss);
      stayButton.addEventListener('click', dismiss);

      document.addEventListener('keydown', function onKeyDown(e) {
        if (e.key === 'Escape' && dialog.style.display !== 'none') {
          dismiss();
          document.removeEventListener('keydown', onKeyDown);
        }
      });

      switchLink.addEventListener('click', function () {
        if (!testMode && storage) {
          storage.setItem(dismissKey, '1');
        }
        log('info', 'Switch button clicked.', { targetUrl: targetUrl });
      });

      log('info', 'Opening popup.', { targetUrl: targetUrl });
      dialog.style.display = 'block';
    }

    function setup(root) {
      if (!root || root.dataset.enabled !== 'true') {
        log('info', 'Section skipped because popup is disabled.');
        return;
      }

      var sectionId = root.id.replace('GeoDomainSwitch-', '');
      var currentHost = normalizeHost(root.dataset.currentHost || window.location.hostname);
      var testMode = root.dataset.testMode === 'true';
      var params = new URLSearchParams(window.location.search);
      var queryCountryOverride = String(params.get('geo_country') || '').toUpperCase();

      if (queryCountryOverride) {
        log('info', 'Country override applied from query param.', { geo_country: queryCountryOverride });
        run(root, sectionId, queryCountryOverride, currentHost, testMode);
        return;
      }

      fetch('https://ipapi.co/json/')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var visitorCountry = String(data.country_code || '').toUpperCase();
          log('info', 'Country resolved from ipapi.co', { visitorCountry: visitorCountry });
          run(root, sectionId, visitorCountry, currentHost, testMode);
        })
        .catch(function () {
          var visitorCountry = String(root.dataset.visitorCountry || '').toUpperCase();
          log('warn', 'ipapi.co failed, falling back to Shopify country.', { visitorCountry: visitorCountry });
          run(root, sectionId, visitorCountry, currentHost, testMode);
        });
    }

    var roots;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        roots = document.querySelectorAll('.geo-domain-switch');
        log('info', 'DOMContentLoaded, initializing sections.', { sectionCount: roots.length });
        roots.forEach(setup);
      });
      return;
    }

    roots = document.querySelectorAll('.geo-domain-switch');
    log('info', 'Document already loaded, initializing sections.', { sectionCount: roots.length });
    roots.forEach(setup);
  })();

  } catch(e) { console.error(e); }
})();
})();
